// import { Button, Canvas, Container, Label, Overlay, Panel } from '@playcanvas/pcui';
// import { localize } from './localization';
// import imageIcon from './svg/image.svg';
// import {Events} from '../events';

// const createSvg = (svgString: string) => {
//     const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
//     return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
// };

// class AssociatedPicturePanel extends Overlay {
//     constructor(events: Events, args = {}) {
//         args = {
//             ...args,
//             id: 'associated-picture-panel',
//             clickable: true,
//             hidden: true
//         };

//         super(args);

//         const panelHeader = new Container({
//             class: 'panel-header'
//         });

//         const pictureIcon = new Label({
//             class: 'panel-header-icon'
//         });

//         pictureIcon.dom.append(createSvg(imageIcon));

//         const imageLabel = new Label({
//             text: localize('image-viewer'),
//             class: 'panel-header-label'
//         });

//         panelHeader.append(pictureIcon);
//         panelHeader.append(imageLabel);

//         const imgEl = document.createElement('img');
//         imgEl.alt = '';
//         imgEl.src = 'https://www.volkswagen.com.au/content/dam/onehub_pkw/importers/au/technology/scirocco/06-01-Parts.jpg';
//         // imgEl.src = 'https://ducatistore.co.uk/news/wp-content/uploads/2025-ducati-panigale-v4s-1.jpg';
//         imgEl.decoding = 'async';
//         imgEl.loading = 'lazy';
//         // Size and fitting—tweak as you like:
//         imgEl.style.display = 'block';
//         imgEl.style.width = '1366px';
//         imgEl.style.height = '1024px';
//         imgEl.style.objectFit = 'contain'; // or 'cover' / 'fill'

//         const imageContainer = new Container({
//             resizable: 'top',
//             class: 'image-container'
//         });
//         imageContainer.dom.appendChild(imgEl);

//         // Create mask in order to fit image to container when it zoomed in
//         Object.assign(imageContainer.dom.style, {
//           // ...existing styles...
//           clipPath: 'inset(0 round 16px)' // adjust radius
//         });

//         this.append(panelHeader);
//         this.append(imageContainer);

//         // ------- Pan & Zoom state -------
//         let baseScale = 1;   // fits image into the container
//         let zoom = 1;        // user-controlled zoom multiplier
//         let tx = 0, ty = 0;  // translation (in container px)
//         const ZOOM_MIN = 0.1;
//         const ZOOM_MAX = 8;

//         const apply = () => {
//           imgEl.style.transform = `translate(${tx}px, ${ty}px) scale(${baseScale * zoom})`;
//         };

//         const fitToContainer = () => {
//           if (!imgEl.naturalWidth || !imgEl.naturalHeight) return;
//           const rect = imageContainer.dom.getBoundingClientRect();
//           const cw = rect.width, ch = rect.height;
//           const iw = imgEl.naturalWidth, ih = imgEl.naturalHeight;

//           baseScale = Math.min(cw / iw, ch / ih);  // "contain"
//           zoom = 1;

//           // center image
//           const displayW = iw * baseScale;
//           const displayH = ih * baseScale;
//           tx = (cw - displayW) / 2;
//           ty = (ch - displayH) / 2;

//           apply();
//         };

//         // Zoom around a point (px, py) in container coords
//         const zoomAt = (factor: number, px: number, py: number) => {
//           const curScale = baseScale * zoom;
//           // image-space coords under current transform
//           const ix = (px - tx) / curScale;
//           const iy = (py - ty) / curScale;

//           const nextZoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoom * factor));
//           const nextScale = baseScale * nextZoom;

//           // keep (px,py) anchored
//           tx = px - ix * nextScale;
//           ty = py - iy * nextScale;

//           zoom = nextZoom;
//           apply();
//         };

//         // ------- Wheel to zoom -------
//         imageContainer.dom.addEventListener('wheel', (e: WheelEvent) => {
//           e.preventDefault(); // stop page scroll
//           const rect = imageContainer.dom.getBoundingClientRect();
//           const px = e.clientX - rect.left;
//           const py = e.clientY - rect.top;

//           // Smooth, device-independent zoom factor
//           // Negative deltaY => zoom in
//           const factor = Math.exp(-e.deltaY * 0.0015);
//           zoomAt(factor, px, py);
//         }, { passive: false });

//         // ------- Drag to pan (Pointer Events) -------
//         let panning = false;
//         let startX = 0, startY = 0;
//         let startTx = 0, startTy = 0;

//         const onPointerDown = (e: PointerEvent) => {
//           (e.target as Element).setPointerCapture?.(e.pointerId);
//           panning = true;
//           startX = e.clientX;
//           startY = e.clientY;
//           startTx = tx;
//           startTy = ty;
//           imageContainer.dom.style.cursor = 'grabbing';
//         };
//         const onPointerMove = (e: PointerEvent) => {
//           if (!panning) return;
//           const dx = e.clientX - startX;
//           const dy = e.clientY - startY;
//           tx = startTx + dx;
//           ty = startTy + dy;
//           apply();
//         };
//         const onPointerUp = (e: PointerEvent) => {
//           panning = false;
//           imageContainer.dom.style.cursor = 'grab';
//           (e.target as Element).releasePointerCapture?.(e.pointerId);
//         };

//         imageContainer.dom.addEventListener('pointerdown', onPointerDown);
//         window.addEventListener('pointermove', onPointerMove);
//         window.addEventListener('pointerup', onPointerUp);
//         imageContainer.dom.style.cursor = 'grab';

//             // --- API to set the image directly ---
//         const setImage = (src: string | File | Blob) => {
//           // URL / data: URL
//           if (typeof src === 'string') {
//             imgEl.src = src;
//             return;
//           }
//           // File / Blob
//           const url = URL.createObjectURL(src);
//           imgEl.onload = () => URL.revokeObjectURL(url);
//           imgEl.src = url;
//         };

//         // Use from elsewhere:
//         // events.fire('associatedPicturePanel.setImageSrc', 'https://example.com/pic.jpg');
//         // or with a File: events.fire('associatedPicturePanel.setImageSrc', file);
//         events.on('associatedPicturePanel.setImageSrc', setImage);

//         // handle panel visibility
//         const setVisible = (visible: boolean) => {
//             if (visible === this.hidden) {
//                 this.hidden = !visible;
//                 events.fire('associatedPicturePanel.visible', visible);
//             }
//         };

//         events.function('associatedPicturePanel.visible', () => {
//             return !this.hidden;
//         });

//         events.on('associatedPicturePanel.setVisible', (visible: boolean) => {
//             setVisible(visible);
//         });

//         events.on('associatedPicturePanel.toggleVisible', () => {
//             setVisible(this.hidden);
//         });

//         new ResizeObserver(() => {
//             if (imgEl.complete) fitToContainer();
//         }).observe(imageContainer.dom);


//     }
// }

// export { AssociatedPicturePanel };




import { Container, Label, Overlay } from '@playcanvas/pcui';
import { localize } from './localization';
import imageIcon from './svg/image.svg';
import { Events } from '../events';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
};

// 🔧 Tweak these to change mask size / roundness
const MASK_GROW_PX = 12;  // makes the mask larger by this many pixels on each side
const MASK_RADIUS_PX = 24;  // corner radius (was 16px before)

class AssociatedPicturePanel extends Overlay {
    constructor(events: Events, args = {}) {
        args = {
            ...args,
            id: 'associated-picture-panel',
            clickable: true,
            hidden: true
        };
        super(args);

        // full-screen overlay stays untouched; center an inner dialog
        const centerer = new Container({});
        Object.assign(centerer.dom.style, {
            // position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            pointerEvents: 'none'
        });
        this.append(centerer);

        // dialog
        const dialog = new Container({ class: 'associated-picture-dialog' });
        Object.assign(dialog.dom.style, {
            display: 'flex',
            flexDirection: 'column',
            // maxWidth: '95vw',
            // maxHeight: '90vh',
            width: '90vw',
            height: '90vh',
            background: 'transparent',
            pointerEvents: 'auto',
            overflow: 'hidden',          // dialog clips anything beyond it
            borderRadius: `${MASK_RADIUS_PX}px`
        });
        centerer.append(dialog);

        // header
        const panelHeader = new Container({ class: 'panel-header' });
        Object.assign(panelHeader.dom.style, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative'
        });

        const headerLeft = new Container({});
        Object.assign(headerLeft.dom.style, {
            display: 'flex',
            alignItems: 'center'
        });

        const pictureIcon = new Label({ class: 'panel-header-icon' });
        pictureIcon.dom.append(createSvg(imageIcon));
        const imageLabel = new Label({ text: localize('image-viewer'), class: 'panel-header-label' });
        headerLeft.append(pictureIcon);
        headerLeft.append(imageLabel);

        // Close button
        const closeButton = new Container({ class: 'panel-close-button' });
        closeButton.dom.innerHTML = '✕';
        Object.assign(closeButton.dom.style, {
            cursor: 'pointer',
            fontSize: '24px',
            color: '#fff',
            padding: '4px 8px',
            userSelect: 'none'
        });

        closeButton.dom.addEventListener('click', () => {
            this.hidden = true;
            events.fire('associatedPicturePanel.visible', false);
        });

        closeButton.dom.addEventListener('mouseenter', () => {
            closeButton.dom.style.color = '#ff5555';
        });

        closeButton.dom.addEventListener('mouseleave', () => {
            closeButton.dom.style.color = '#fff';
        });

        panelHeader.append(headerLeft);
        panelHeader.append(closeButton);
        dialog.append(panelHeader);

        // image + container
        const imgEl = document.createElement('img');
        imgEl.alt = '';
        imgEl.decoding = 'async';
        imgEl.loading = 'lazy';
        imgEl.style.display = 'block';
        imgEl.style.objectFit = 'contain';
        imgEl.style.transformOrigin = '0 0';

        const imageContainer = new Container({
            resizable: 'top',
            class: 'image-container'
        });
        imageContainer.dom.appendChild(imgEl);

        Object.assign(imageContainer.dom.style, {
            position: 'relative',
            flex: '1 1 60vh',
            minHeight: '200px',
            width: '100%',
            // make the mask “larger by length”: expand outward with a negative inset
            // (dialog still clips anything beyond its own bounds)
            overflow: 'visible',
            clipPath: `inset(${-MASK_GROW_PX}px round ${MASK_RADIUS_PX}px)`
        });

        dialog.append(imageContainer);

        // pan & zoom
        let baseScale = 1, zoom = 1, tx = 0, ty = 0;
        const ZOOM_MIN = 0.1, ZOOM_MAX = 8;

        const apply = () => {
            imgEl.style.transform = `translate(${tx}px, ${ty}px) scale(${baseScale * zoom})`;
            imgEl.draggable = false;
        };

        const fitToContainer = () => {
            if (!imgEl.naturalWidth || !imgEl.naturalHeight) return;

            // NOTE: we still use the container's rect for fitting; the expanded mask
            // just gives a little extra visual bleed inside the dialog.
            const rect = imageContainer.dom.getBoundingClientRect();
            const cw = rect.width, ch = rect.height;
            const iw = imgEl.naturalWidth, ih = imgEl.naturalHeight;

            baseScale = Math.min(cw / iw, ch / ih);
            zoom = 1;

            const displayW = iw * baseScale;
            const displayH = ih * baseScale;
            tx = (cw - displayW) / 2;
            ty = (ch - displayH) / 2;

            apply();
        };

        imgEl.addEventListener('load', () => fitToContainer());

        const zoomAt = (factor: number, px: number, py: number) => {
            const curScale = baseScale * zoom;
            const ix = (px - tx) / curScale;
            const iy = (py - ty) / curScale;

            const nextZoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoom * factor));
            const nextScale = baseScale * nextZoom;

            tx = px - ix * nextScale;
            ty = py - iy * nextScale;

            zoom = nextZoom;
            apply();
        };

        imageContainer.dom.addEventListener('wheel', (e: WheelEvent) => {
            e.preventDefault();
            const rect = imageContainer.dom.getBoundingClientRect();
            const px = e.clientX - rect.left;
            const py = e.clientY - rect.top;
            const factor = Math.exp(-e.deltaY * 0.0015);
            zoomAt(factor, px, py);
        }, { passive: false });

        // pan
        let panning = false, startX = 0, startY = 0, startTx = 0, startTy = 0;
        const onPointerDown = (e: PointerEvent) => {
            (e.target as HTMLElement).setPointerCapture?.(e.pointerId);
            panning = true;
            startX = e.clientX; startY = e.clientY;
            startTx = tx; startTy = ty;
            imageContainer.dom.style.cursor = 'grabbing';
        };
        const onPointerMove = (e: PointerEvent) => {
            if (!panning) return;
            tx = startTx + (e.clientX - startX);
            ty = startTy + (e.clientY - startY);
            apply();
        };
        const onPointerUp = (e: PointerEvent) => {
            panning = false;
            imageContainer.dom.style.cursor = 'grab';
            (e.target as HTMLElement).releasePointerCapture?.(e.pointerId);
        };

        imageContainer.dom.addEventListener('pointerdown', onPointerDown);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        imageContainer.dom.style.cursor = 'grab';

        // API
        const setImage = (src: string | File | Blob) => {
            if (typeof src === 'string') {
                imgEl.src = src;
                return;
            }
            const url = URL.createObjectURL(src);
            imgEl.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });
            imgEl.src = url;
        };
        events.on('associatedPicturePanel.setImageSrc', setImage);

        events.on('show-associated-picture', () => {
            if (imgEl.complete) fitToContainer();
        });

        const setVisible = (visible: boolean) => {
            if (visible === this.hidden) {
                this.hidden = !visible;
                events.fire('associatedPicturePanel.visible', visible);
                if (visible && imgEl.complete) fitToContainer();
            }
        };
        events.function('associatedPicturePanel.visible', () => !this.hidden);
        events.on('associatedPicturePanel.setVisible', (visible: boolean) => setVisible(visible));
        events.on('associatedPicturePanel.toggleVisible', () => setVisible(this.hidden));

        new ResizeObserver(() => {
            if (imgEl.complete) fitToContainer();
        }).observe(imageContainer.dom);
        window.addEventListener('resize', () => {
            if (imgEl.complete) fitToContainer();
        });

        this.hidden = true; // start hidden
    }
}

export { AssociatedPicturePanel };
